import { userHasPremiumSessionRecording } from '@shared/user-settings/flags'
import { useAuth } from '../../../contexts/auth-context'

/**
 * Whether the signed-in user holds the admin "Premium Session Recording"
 * switch. UI gate only — every session-recording API route re-checks it. The
 * profile refreshes on focus, so an admin change shows up without a sign-out.
 */
export function usePremiumSessionRecording(): boolean {
  const { user } = useAuth()
  return userHasPremiumSessionRecording(user)
}
